export default "__VITE_PUBLIC_ASSET__133ff42e__"